import { useCallback, useState } from 'react';
import { learnerApi } from '../services/learnerApi';

export function useSupervisionCode() {
  const [code, setCode] = useState(null);
  const [expiresAt, setExpiresAt] = useState(null);
  const [generating, setGenerating] = useState(false);
  const [error, setError] = useState(null);

  const generate = useCallback(async () => {
    setGenerating(true);
    setError(null);
    try {
      const res = await learnerApi.generateSupervisionCode({});
      setCode(res?.code || null);
      setExpiresAt(res?.expiresAt || null);
      return res;
    } catch (e) {
      setError(e?.message || 'Failed to generate code.');
      throw e;
    } finally {
      setGenerating(false);
    }
  }, []);

  const reset = useCallback(() => {
    setCode(null);
    setExpiresAt(null);
    setError(null);
  }, []);

  return { code, expiresAt, generating, error, generate, reset };
}
